// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreateEntitlementResponse
 */
export interface CreateEntitlementResponse {
  /**
   * id of the created entitlement
   * @type {string}
   * @memberof CreateEntitlementResponse
   */
  id: string;
}

/**
 * Check if a given object implements the CreateEntitlementResponse interface.
 */
export function instanceOfCreateEntitlementResponse(
  value: object,
): value is CreateEntitlementResponse {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function CreateEntitlementResponseFromJSON(
  json: any,
): CreateEntitlementResponse {
  return CreateEntitlementResponseFromJSONTyped(json, false);
}

export function CreateEntitlementResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateEntitlementResponse {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
  };
}

export function CreateEntitlementResponseToJSON(
  json: any,
): CreateEntitlementResponse {
  return CreateEntitlementResponseToJSONTyped(json, false);
}

export function CreateEntitlementResponseToJSONTyped(
  value?: CreateEntitlementResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
  };
}
